import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CasesResults from '../results/CasesResults';
import CasesPartyResults from '../results/CasesPartyResults';
import EntriesResults from '../results/EntriesResults';
import { Loading } from '../../common/Loading';
import {
  resetAdvancedSearch,
  searchAdvancedFilings,
  getPetitionPdf,
} from '../../../redux/actions/advancedSearchAction';
import PetitionResults from './PetitionResults';
import ScheduleResults from './ScheduleResults';
import CaseActivityResults from './CaseActivityResults';

const AdvancedSearchResults = ({
  data,
  isLoading,
  showResults,
  resultsFilter,
  onReset,
  onAdvancedSearch,
  onGetPetitionPdf,
}) => {
  const isCase =
    resultsFilter.grouped || (data.results && data.results.length > 0 && data.results[0].document_type === 'cases');
  const resultTypes = {
    cases: CasesPartyResults,
    schedules: ScheduleResults,
    petitions: PetitionResults,
    general: isCase ? CasesResults : EntriesResults,
    'case-activity': CaseActivityResults,
  };
  const Results = resultTypes[resultsFilter.tab];

  return (
    showResults && (
      <section className="advanced-search-results">
        {isLoading ? (
          <Loading show={isLoading} />
        ) : data.results && data.results.length > 0 ? (
          <Results
            data={data}
            filter={resultsFilter}
            onReset={onReset}
            onSearch={onAdvancedSearch}
            onGetPetitionPdf={onGetPetitionPdf}
          />
        ) : (
          <div>No results found</div>
        )}
      </section>
    )
  );
};

AdvancedSearchResults.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.any,
  onReset: PropTypes.func.isRequired,
  onAdvancedSearch: PropTypes.func.isRequired,
};

AdvancedSearchResults.defaultProps = {
  isLoading: false,
  data: {},
};

const mapStateToProps = state => ({ ...state.get('advancedSearch').toJS() });

const mapDispatchToProps = {
  onReset: resetAdvancedSearch,
  onAdvancedSearch: searchAdvancedFilings,
  onGetPetitionPdf: getPetitionPdf,
};
export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchResults);



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/AdvancedSearchResults.jsx